import type { EdgeLineOption } from '@/modules/Edge';

export const EDGE_LINES: Record<string, EdgeLineOption> = {
	NONE: {VALUE: 'none', ICON: null},
	SHARP: {VALUE: 'sharp', ICON: 'icon--edge-arrow-1'},
	STRAIGHT: {VALUE: 'straight', ICON: 'icon--edge-arrow-2'},
	WIDE: {VALUE: 'wide', ICON: 'icon--edge-arrow-3'},
	DOT: {VALUE: 'dot', ICON: 'icon--edge-arrow-dot'}
};
